import { Dimmer, Loader } from "semantic-ui-react";

export const Loading = () => (
  <div style={{ margin: "24px 0px" }}>
    <Dimmer active inverted>
      <Loader inverted>Betöltés ...</Loader>
    </Dimmer>
  </div>
);
